
import {Component, Vue} from "vue-property-decorator";
import {SenkronRaporCevap, SenkronRaporSatiri} from "@/services/senkronPlanService";
import {
  gunDamgasi,
  gunKaydir,
  ileriGidilebilirMi
} from "@/components/eicrapro/senkron/senkronRaporOzeti";

/**
 * Plan ekranındaki koşum geçmişi (Faz 3, Ö-P2 kararı).
 *
 * TEK GÜNLÜK, gün gün gezilir. `GET /v1/senkron-rapor` yalnız `?gun=` alıyor;
 * çok günlük bir uç yok ve Faz 3'te backend'e dokunulmadı. Çok gecelik zaman
 * tüneli istenirse toplu bir uç gerekir (F4).
 */
@Component
export default class SenkronRaporGecmisi extends Vue {
  gun = gunDamgasi();

  get rapor(): SenkronRaporCevap | null {
    return this.$store.getters["senkronPlan/raporByGun"](this.gun);
  }

  get satirlar(): Array<SenkronRaporSatiri> {
    return this.rapor?.planlar ?? [];
  }

  get yukleniyor(): boolean {
    return this.$store.getters["senkronPlan/raporYukleniyor"];
  }

  get hata(): string | null {
    return this.$store.getters["senkronPlan/raporHatasi"];
  }

  get ileriGidilebilir(): boolean {
    return ileriGidilebilirMi(this.gun);
  }

  mounted() {
    this.yukle();
  }

  yukle(zorla = false) {
    this.$store.dispatch("senkronPlan/raporYukle", {gun: this.gun, zorla});
  }

  yenile() {
    this.yukle(true);
  }

  gunDegistir(fark: number) {
    if (fark > 0 && !this.ileriGidilebilir) return;
    this.gun = gunKaydir(this.gun, fark);
    this.yukle();
  }

  bugune() {
    this.gun = gunDamgasi();
    this.yukle();
  }
}
